let nextTick = 0;
/**
 * Helps creating subscribeable poll
 * @param actions
 * @param caller
 * @param interval value in seconds
 * @returns {function(dispatch: Function): Function}
 */
export default function createSubscribeAction(subscribe, interval = 1000) {
  return (dispatch) => {
    const id = nextTick;
    nextTick += 1;
    let unsubscribed = false;
    const subscription = subscribe(dispatch, id);
    let timer;
    let done = true;
    let reset;
    const cancel = () => {
      if (!done && subscription.cancel) {
        subscription.cancel(dispatch);
      }
    };
    const call = () => {
      if (unsubscribed) {
        return;
      }
      done = false;
      Promise.resolve(subscription.call(dispatch))
        .then(reset)
        .catch(reset);
    };
    reset = () => {
      done = true;
      clearTimeout(timer);
      timer = setTimeout(call, interval);
    };
    call();
    return () => {
      unsubscribed = true;
      clearTimeout(timer);
      cancel();
    };
  };
}



// WEBPACK FOOTER //
// ./src/helpers/createSubscribeAction.js